const IconArrowDown = () => {
  return (
    <svg width="8" height="5" viewBox="0 0 8 5" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M0.94 0L4 3.06L7.06 0L8 0.946667L4 4.94667L0 0.946667L0.94 0Z" fill="white" fillOpacity="0.87" />
    </svg>
  )
}

export default IconArrowDown
